var map = {
	"./logo-greater_good.png": 232,
	"./logo-inc.png": 233,
	"./logo-ted.png": 234,
	"./logo-ted.svg": 558,
	"./thumb-inc.png": 235,
	"./thumb-ted.png": 236
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 557;


//////////////////
// WEBPACK FOOTER
// ./src/imgs/articles ^\.\/.*$
// module id = 557
// module chunks = 0